import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

export const MobileAppPlatformIcon = createValidIcon((props) => {
  const { size = 72 } = props

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 72 72'
      fill='none'
    >
      <path
        d='M72 36C72 55.8823 55.8823 72 36 72C16.1177 72 0 55.8823 0 36C0 16.1177 16.1177 0 36 0C55.8823 0 72 16.1177 72 36Z'
        fill='url(#paint0_linear_21_5183)'
      />
      <path
        d='M71.5 36C71.5 16.3939 55.6061 0.5 36 0.5C16.3939 0.5 0.5 16.3939 0.5 36C0.5 55.6061 16.3939 71.5 36 71.5V72C16.1177 72 0 55.8823 0 36C0 16.1177 16.1177 0 36 0C55.8823 0 72 16.1177 72 36C72 55.8823 55.8823 72 36 72V71.5C55.6061 71.5 71.5 55.6061 71.5 36Z'
        fill='url(#paint1_linear_21_5183)'
        fillOpacity='0.5'
      />
      <path
        d='M32.7286 44.5831C31.911 44.5831 31.1354 44.1429 30.7161 43.4301L26.796 36.6381C26.3768 35.9253 26.3768 35.0449 26.796 34.3112L30.7161 27.5191C31.1354 26.8063 31.8901 26.3661 32.7286 26.3661H39.5416L44.9501 16.9956C44.8244 16.9956 44.7195 16.9746 44.5938 16.9746H28.6827C27.0057 16.9746 25.4544 17.876 24.5949 19.3225L16.6289 33.1163C15.7904 34.5627 15.7904 36.3655 16.6289 37.833L24.5949 51.6267C25.4334 53.0732 26.9847 53.9746 28.6827 53.9746H44.6147C44.7405 53.9746 44.8453 53.9746 44.9711 53.9536L39.5626 44.5831H32.7286Z'
        fill='#FF0044'
      />
      <path
        d='M56.6476 33.1163L48.6816 19.3225C48.6187 19.2177 48.5558 19.1338 48.4929 19.029L43.0844 28.3995L46.5014 34.3112C46.9207 35.0239 46.9207 35.9044 46.5014 36.6381L43.0844 42.5497L48.4929 51.9202C48.5558 51.8154 48.6187 51.7315 48.6816 51.6267L56.6476 37.833C57.4861 36.3865 57.4861 34.5837 56.6476 33.1163Z'
        fill='#28F981'
      />
      <defs>
        <linearGradient
          id='paint0_linear_21_5183'
          x1='30.5'
          y1='26.5'
          x2='27.4703'
          y2='-17.4445'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4A0619' />
          <stop offset='1' stopColor='#D9013B' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_21_5183'
          x1='12.5'
          y1='6'
          x2='62'
          y2='66.5'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF0044' />
          <stop offset='0.471154' stopColor='#450000' />
          <stop offset='1' stopColor='#FF0044' />
        </linearGradient>
      </defs>
    </svg>
  )
})
